import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TransactionalEvent } from '@app/shared/interfaces/transactional-event';
import { AppConfig } from '@config/app.config';
import { TransactionalEventsRepository } from '@core/repositories/transactional-events.repository';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApiTransactionalEventsRepository implements TransactionalEventsRepository {
  public url = this.appConfig.URL + '/segments/';

  constructor(public appConfig: AppConfig, public http: HttpClient) {}

  getItems(): Observable<any> {
    return this.http.get(this.url);
  }

  add(transactionalEvent: TransactionalEvent): Observable<any> {
    const data = {
      data: {
        id: transactionalEvent.id,
        type: 'Segment',
        attributes: {
          name: transactionalEvent.name
        }
      }
    };
    return this.http.post(this.url, data);
  }

  edit(transactionalEvent: TransactionalEvent): Observable<any> {
    const data = {
      data: {
        id: transactionalEvent.id,
        type: 'Segment',
        attributes: {
          name: transactionalEvent.name
        }
      }
    };
    return this.http.put(this.url, data);
  }

  delete(item: any): Observable<any> {
    return this.http.delete(this.url + item);
  }
}
